import styled from "styled-components";

import {
  MacroTemplateContainer,
  OverviewMacroTemplateContainer,
} from "../../styles";

export const ButtonTemplatesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
`;

export const ButtonTemplateContainer = styled(MacroTemplateContainer)`
  display: grid;
  place-content: center;
  border-radius: 12px;
  height: 80px;
  cursor: pointer;
`;
export const OverviewButtonTemplateContainer = styled(
  OverviewMacroTemplateContainer
)`
  display: grid;
  place-content: center;
  border-radius: 12px;
  height: 80px;
  cursor: pointer;
`;
